import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
import {HawalaBranchesListHeader} from './components/header/HawalaBranchesListHeader'
import {HawalaBranchesTable} from './table/HawalaBranchesTable'
import {HawalaBranchEditModal} from './hawala-branch-edit-modal/HawalaBranchEditModal'
import {KTCard} from '../../../../_metronic/helpers'

const HawalaBranchesList = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
        <HawalaBranchesListHeader />
        <HawalaBranchesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <HawalaBranchEditModal />}
    </>
  )
}

const HawalaBranchesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <HawalaBranchesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {HawalaBranchesListWrapper}
